import { Link } from 'react-router-dom';
import * as style from '../../utils/general_style.js';
import * as links from '../../utils/general_links.js';
import logo from '../../assets/logo_presentis_blanc.png';
import FooterList from './FooterList';

function Footer() {
    const aPropos = {
        title: 'À propos de PRESENTIS',
        routes: [
            { 
                path: links.ROUTES.home, 
                label: 'Accueil'
            }, {
                path: links.ROUTES.planDuSite,
                label: 'Plan du site'
            }, {
                path: links.ROUTES.quiSommesNous,
                label: 'Qui sommes-nous ?'
            }
        ]
    };

    const legal = {
        title: 'Légalité',
        routes: [
            {
                path: links.ROUTES.mentionsLegales, 
                label: 'Mentions Légales'
            }, {
                path: links.ROUTES.politiqueCookies, 
                label:'Politique relative aux cookies'
            }, { 
                path: links.ROUTES.politiqueProtection,
                label: 'Politique de protection des données personnelles'
            }
        ]
    };

    const contact = {
        title: 'Contact',
        routes: [
            {
                path: `mailto:${links.CONTACT.email}`,
                label: links.CONTACT.email,
                icon: "fa-solid fa-envelope"
            }, {
                path: `tel:${links.CONTACT.tel}`,
                label: links.CONTACT.tel,
                icon: "fa-solid fa-phone"
            }, {
                path: links.ROUTES.contact,
                label: 'Formulaire de contact',
            }
        ]
    };

	return (
        <footer style={{...style.ROW_SPACE_BETWEEN, alignItems: 'inherit', background: 'linear-gradient(240deg,rgb(61 70 151) 20%,rgb(255 99 0) 100%)', padding: '25px', width: '100%'}}>
            <div style={{...style.COLUMN_START, width: '100%'}}>
                    <div style={{width: '221px', cursor: 'pointer'}}>
                    <Link to={ links.ROUTES.home } style={{justifyContent: 'start'}}>
                        <img src={ logo } alt="logo PRESENTIS" />
                    </Link>
                </div>
            </div>
            <FooterList listData={ aPropos } />
            <FooterList listData={ legal } />
            <FooterList listData={ contact } />
        </footer>
	);
};

export default Footer;